import { ErrorBoundaryHoc } from "@components/boundary/ErrorBoundaryHoc";

export default ErrorBoundaryHoc(ErrorWrapper);

function ErrorWrapper() {
	return null;
}
